export default __webpack_public_path__ + "static/media/Contact Page Image 2.581a689a.png";